import {useAtom} from 'jotai';
import {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {SidePanel} from '@/components/SidePanel';
import {useSession} from '@/hooks';
import {mapSideInfoAtom} from '@/map/atom';
import {MapSideMenuType} from '@/map/enums';
import {FindStores} from '../FindStores';
import {StarredBrands} from '../StarredBrands';
import {MoreMenu} from './MoreMenu';

interface IProps {
  replaceMapRoot?(): void;
}

export const MapSidePanel = ({replaceMapRoot}: IProps) => {
  const [sideInfo, setSideInfo] = useAtom(mapSideInfoAtom);
  const params = useParams<{
    menu?: MapSideMenuType;
  }>();
  const {isOpenPreRegistrationUser} = useSession();

  const onChangeOpenStatus = (status: boolean) => {
    setSideInfo((prev) => ({
      ...prev,
      open: status,
    }));
  };

  useEffect(() => {
    const menu = params?.menu;

    if (!menu?.length && sideInfo.menu === MapSideMenuType.more) {
      return;
    } else if (menu?.length && !Object.values(MapSideMenuType).includes(menu)) {
      return replaceMapRoot?.();
    }

    setSideInfo({
      menu,
      open: !!menu?.length,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  useEffect(() => {
    return () => {
      setSideInfo({
        open: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sideInfo.menu === MapSideMenuType.stores && !isOpenPreRegistrationUser) {
      replaceMapRoot?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenPreRegistrationUser, sideInfo.menu]);

  if (!sideInfo || !sideInfo.menu) {
    return null;
  }

  return (
    <SidePanel
      hasHandle={!!sideInfo.menu}
      open={sideInfo?.open}
      onChangeState={onChangeOpenStatus}
    >
      {sideInfo.menu === MapSideMenuType.stores && <FindStores />}
      {sideInfo.menu === MapSideMenuType.starredBrands && <StarredBrands />}
      {sideInfo.menu === MapSideMenuType.more && <MoreMenu />}
    </SidePanel>
  );
};
